import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CUSTOM_TIMEFRAME,
  DEFAULT_TIMEFRAME,
} from 'components/pages/settings/atoOverview/constants'
import { mapOverview } from 'components/pages/settings/atoOverview/presenters'

import {
  BLOCKED_CODES,
  CUSTOM_RANGE_CHANGE,
  FETCH_ATO_OVERVIEW_ASYNC,
  TIMEFRAME_CHANGE,
} from './constants'

const DEFAULT_ERROR = 'Failed to load the account takeover overview.'

// Same readiness test as the epic: a half-picked custom range fetches nothing,
// so showing the loader would leave it spinning forever.
const willFetch = (timeframe, customRange) =>
  timeframe !== CUSTOM_TIMEFRAME || Boolean(customRange?.from && customRange?.to)

// The 403 body words each case itself; extractErrorMessage would flatten it
// into "detail: ...; code: ...".
const messageOf = (error) => {
  const body = error?.response
  if (typeof body?.detail === 'string') return body.detail
  return error?.detail ?? DEFAULT_ERROR
}

const codeOf = (error) => {
  const code = error?.response?.code
  return BLOCKED_CODES.includes(code) ? code : null
}

export default function () {
  const initialState = {
    // Always the default. The pick is deliberately not remembered: a page
    // that reopened on someone's old 7d read as a broken default.
    timeframe: DEFAULT_TIMEFRAME,
    customRange: null,
    data: null,
    loader: true,
    error: null,
    accessDenied: false,
    errorCode: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case FETCH_ATO_OVERVIEW_ASYNC.INITIATE:
        return { ...state, loader: true }
      case TIMEFRAME_CHANGE: {
        const { timeframe } = action.payload
        const customRange = timeframe === CUSTOM_TIMEFRAME ? state.customRange : null
        return {
          ...state,
          timeframe,
          customRange,
          loader: willFetch(timeframe, customRange),
        }
      }
      case CUSTOM_RANGE_CHANGE:
        return {
          ...state,
          timeframe: CUSTOM_TIMEFRAME,
          customRange: action.payload.range,
          loader: willFetch(CUSTOM_TIMEFRAME, action.payload.range),
        }
      case FETCH_ATO_OVERVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          data: mapOverview(action.payload),
          loader: false,
          error: null,
          accessDenied: false,
          errorCode: null,
        }
      case FETCH_ATO_OVERVIEW_ASYNC.ERROR:
        return {
          ...state,
          data: null,
          loader: false,
          error: messageOf(action.error),
          // Any 403 is final: no timeframe and no retry can change it.
          accessDenied: action.error?.status === 403,
          errorCode: codeOf(action.error),
        }
      case FETCH_ATO_OVERVIEW_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
